import { evaluate, processPayloadTemplate, parse } from '@code2io/common-flow-utilities';
import * as jp from 'jsonpath';
import { createElement } from 'react';
import { componentCreator } from '../components/ComponentManager.js';
import GenericWrapper from '../components/GenericWrapper.js';
import { componentPropertyTypesConfig } from '../resources/componentPropertyTypesConfig.js';
import { getComponentPropertyValue } from '../resources/componentPropertyTypesHelper.js';
import { flowExecutor } from './be-connector.js';

const propChecker = (props, variables, component, templates) => {
    if (Array.isArray(props)) {
        return props.map(prop => getAttrValue(prop, Object.assign(Object.assign({}, variables), { component }), templates));
    }
    else {
        return Object.fromEntries(Object.entries(props).map(([key, value]) => {
            var _a, _b;
            if (key === "className") {
                if (typeof value === "string") {
                    return [key, value];
                }
                return [
                    key,
                    Object.entries(value)
                        .filter(([key, value]) => {
                        if (typeof value === "boolean") {
                            return value;
                        }
                        else if (value === "false") {
                            return false;
                        }
                        else if (value === "true") {
                            return true;
                        }
                        else if (typeof value === "string") {
                            return !!getAttrValue(value, Object.assign(Object.assign({}, variables), { component }), templates);
                        }
                        return false;
                    })
                        .map(([key, value]) => key)
                        .join(" ")
                ];
            }
            const computedValue = getAttrValue(value, Object.assign(Object.assign({}, variables), { component }), templates);
            const propertyTypeConfig = (_b = (_a = componentPropertyTypesConfig[component.package]) === null || _a === void 0 ? void 0 : _a[component.type]) === null || _b === void 0 ? void 0 : _b[key];
            if (typeof propertyTypeConfig !== "undefined") {
                return [key, getComponentPropertyValue(computedValue, propertyTypeConfig)];
            }
            return [key, computedValue];
        }));
    }
};
const jsonPathChecker = (str) => {
    return str.split('$.').length > 1;
};
const getJPValue = (jsonP, json) => {
    return jp.value(json, jsonP);
};
const expChecker = (str) => {
    const expArr = parse(str);
    return expArr.some(exp => exp.type === 'expr');
};
const jsxChecker = (str) => {
    return str.split('::')[0] === 'temp';
};
const jsxRenderer = (str, components, variables) => {
    const templateName = str.split('::')[1];
    return componentCreator(components[templateName], variables);
};
const fnChecker = (str) => {
    return str.split('::')[0] === 'fn';
};
const renderChecker = (str) => {
    return str.split('::')[0] === 'smartLayoutRenderer';
};
const smartLayoutRenderer = (component, children, variables) => {
    if (component.ignoreError) {
        return GenericWrapper({ comp: component, children, ignoreError: true });
    }
    else {
        return createElement(GenericWrapper, { comp: component, item: variables && variables.item ? variables.item : null }, children);
    }
};
const flowChecker = (str) => {
    return str.split('::')[0] === 'exec';
};
const getAttrValue = (attr, obj, components) => {
    if (typeof attr === 'string') {
        if (expChecker(attr)) {
            const vars = Object.fromEntries(Object.entries(obj).map(([key, val]) => {
                if (val && val.value)
                    return [key, val.value];
                return [key, val];
            }));
            return evaluate(attr, vars);
        }
        else if (renderChecker(attr)) {
            return (props) => {
                return smartLayoutRenderer(props.meta, props.children, obj);
            };
        }
        else if (flowChecker(attr)) {
            return (...args) => {
                flowExecutor.trigger(attr.split("::")[1], { params: args }, Object.assign(Object.assign({}, obj), components));
            };
        }
        else if (jsonPathChecker(attr)) {
            return getJPValue(attr, obj);
        }
        else if (jsxChecker(attr)) {
            return jsxRenderer(attr, components, obj);
        }
        else if (fnChecker(attr)) {
            return (item) => {
                return jsxRenderer(attr, components, Object.assign(Object.assign({}, obj), { item }));
            };
        }
        else if (typeof attr === 'number' || typeof attr === 'boolean' || typeof attr === 'string') {
            return attr;
        }
    }
    else if (typeof attr === 'object' && attr !== null && obj.component) {
        return propChecker(attr, obj, obj.component, components);
    }
    else if (typeof attr === "object" && !Array.isArray(attr) && attr !== null) {
        return processPayloadTemplate(attr, obj);
    }
    else {
        return attr;
    }
};

export { expChecker, getAttrValue, getJPValue, propChecker };
//# sourceMappingURL=propChecker.js.map
